import { render } from "./FeatureBox.vue?vue&type=template&id=215bb94e"
import script from "./FeatureBox.vue?vue&type=script&lang=js"
export * from "./FeatureBox.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "215bb94e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('215bb94e', script)) {
    api.reload('215bb94e', script)
  }
  
  module.hot.accept("./FeatureBox.vue?vue&type=template&id=215bb94e", () => {
    api.rerender('215bb94e', render)
  })

}

script.__file = "resources/js/Pages/Station/Partials/Features/FeatureBox.vue"

export default script